import { TokenTypes } from '@bizzdesign/bizzdesign-sdk';
import { type Environment } from '../app/app.config';

export const environment: Environment = {
  production: false,
  type: 'development',
  cognitoRegion: '',
  cognitoDomain: '',
  cognitoCallbackUrl: '',
  cognitoUserPoolId: '',
  cognitoClientId: '',
  configUrl: '',
  appSyncUrl: '',
  appSyncRealtimeUrl: '',
  minimumLogLevel: 'warn',
  useTokenType: TokenTypes.ACCESS_TOKEN,
  queryBatchEnabled: false,
  enableCache: {
    attributeCategoryDefinitions: false,
  },
  queryBatchMaxRequests: 0,
  queryBatchInterval: 0,
  batchImport: {
    parallelRequests: 5,
    batchSize: 25,
  },
  importNuvoDeveloperMode: true,
  importNuvoLicenseKey: '',
  collaborationServers: {
    signalingServers: ['wss://collab-ws-eu-west-1.integration.bizzdesign.dev'],
  },
  featureFlags: {
    aiSearchEnabled: false,
    manageAttributesEnabled: false,
    integrationsEnabled: false,
    populationsEnabled: false,
    customTemplatesEnabled: false,
    workspaceOverviewEnabled: false,
    dataImportV2Enabled: true,
    addToFrameWithoutSelectionEnabled: false,
    fromRepoDeletionEnabled: false,
    addViewToFrameEnabled: false,
    publishingFlowV2Enabled: false,
    aiSearchCypherQueryEnabled: false,
    imagesOnFramesEnabled: false,
    workspacesCacheEnabled: false,
    workspacesCachePayload: null,
    designAssistantModelerSDKLayoutEnabled: false,
    skillManagementEnabled: false,
    trialExperienceEnabled: null,
    aiAssistantFeedbackV2: null,
    enableDesignAssistantInsightSuggestions: false,
    aiAssistantFileUploadEnabled: false,
    aiAssistantDeliverablePersistence: false,
    aiAssistantUnifiedEnabled: false,
    iconLeftPlacementEnabled: false,
    verticalTextAlignmentEnabled: false,
    objectSearchResultsTableEnabled: false,
    devClippyEnabled: false,
    frameCommentsEnabled: false,
    createWorkspaceWithSourcesEnabled: false,
  },
  posthogConfig: {
    group: 'internal',
    tenantId: '',
    trackingEnabled: false,
    posthogApiKey: 'phc_GsXYjP2DNSIFadysuOvDVOGyatwDaEQA8x9GiCYqZ7a',
    posthogUiHost: 'https://eu.posthog.com',
    posthogApiHost: 'https://t.svc.unify.cloud',
  },
  aiAssistant: {
    triggerWorkflowEndpoint: '/orchestrator',
    checkWorkflowStatusEndpoint:
      '/webhook/9b3763e1-2d6f-40ff-a8d8-1aaeee796434',
    chatEndpoint: '/chat',
  },
  userflow: {
    userflowKey: '',
    customerName: '',
  },
  aiWorkflowsConfig: undefined,
  unifyManagementUrl: '',
};
